/**
 * Hero Slideshow — Swiper (fade) initializer
 * Works with multiple instances per page and supports the Shopify theme editor.
 */
(function () {
  'use strict';

  function toBool(value) {
    return value === true || value === 'true';
  }

  function setActiveContent(container, activeIndex) {
    var slides = container.querySelectorAll('.hero-slide');
    slides.forEach(function (slide, index) {
      var content = slide.querySelector('[data-hero-content]');
      if (!content) return;
      if (index === activeIndex) {
        // Restart the entrance animation every time the slide becomes active.
        content.classList.remove('is-active');
        // Force reflow so the removed class actually resets before re-adding it.
        void content.offsetWidth;
        content.classList.add('is-active');
      } else {
        content.classList.remove('is-active');
      }
    });
  }

  function initHeroSlideshow(container) {
    if (!container || container.dataset.heroInitialized === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var swiperEl = container.querySelector('.hero-slideshow__swiper');
    if (!swiperEl) return;

    var autoplayEnabled = toBool(container.dataset.autoplay);
    var autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 5000;
    var speed = parseInt(container.dataset.speed, 10) || 800;
    var loop = toBool(container.dataset.loop);
    var pauseOnHover = toBool(container.dataset.pauseOnHover);

    container.style.setProperty('--hs-speed', speed + 'ms');

    var slideCount = container.querySelectorAll('.swiper-slide').length;

    var options = {
      modules: window.SwiperModules || undefined,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: speed,
      loop: loop && slideCount > 1,
      allowTouchMove: slideCount > 1,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      navigation: {
        nextEl: container.querySelector('.hero-slideshow__nav--next'),
        prevEl: container.querySelector('.hero-slideshow__nav--prev'),
      },
      pagination: container.querySelector('.hero-slideshow__pagination')
        ? {
            el: container.querySelector('.hero-slideshow__pagination'),
            clickable: true,
          }
        : false,
      on: {
        init: function (swiper) {
          setActiveContent(container, swiper.realIndex);
        },
        slideChangeTransitionStart: function (swiper) {
          setActiveContent(container, swiper.realIndex);
        },
      },
    };

    if (autoplayEnabled && slideCount > 1) {
      options.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover,
      };
    }

    var instance = new Swiper(swiperEl, options);

    container.swiperInstance = instance;
    container.dataset.heroInitialized = 'true';
  }

  function destroyHeroSlideshow(container) {
    if (container && container.swiperInstance) {
      container.swiperInstance.destroy(true, true);
      container.swiperInstance = null;
      container.dataset.heroInitialized = 'false';
    }
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-hero-slideshow]').forEach(initHeroSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* ---- Shopify theme editor support ---- */

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector
      ? event.target.querySelector('[data-hero-slideshow]')
      : null;
    if (container) initHeroSlideshow(container);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target.querySelector
      ? event.target.querySelector('[data-hero-slideshow]')
      : null;
    destroyHeroSlideshow(container);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var container = event.target.querySelector
      ? event.target.querySelector('[data-hero-slideshow]')
      : null;
    if (container && container.swiperInstance) {
      container.swiperInstance.autoplay.stop();
    }
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var container = event.target.querySelector
      ? event.target.querySelector('[data-hero-slideshow]')
      : null;
    if (container && container.swiperInstance && toBool(container.dataset.autoplay)) {
      container.swiperInstance.autoplay.start();
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest ? event.target.closest('.hero-slide') : null;
    var container = event.target.closest ? event.target.closest('[data-hero-slideshow]') : null;
    if (!slide || !container || !container.swiperInstance) return;

    var allSlides = Array.prototype.slice.call(container.querySelectorAll('.swiper-slide'));
    var index = allSlides.indexOf(slide);
    if (index > -1) {
      container.swiperInstance.autoplay.stop();
      container.swiperInstance.slideToLoop
        ? container.swiperInstance.slideToLoop(index)
        : container.swiperInstance.slideTo(index);
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var container = event.target.closest ? event.target.closest('[data-hero-slideshow]') : null;
    if (container && container.swiperInstance && toBool(container.dataset.autoplay)) {
      container.swiperInstance.autoplay.start();
    }
  });
})();